(function () {
  'use strict';

  var scheduled = false;
  /*
    Conservative storefront cleanup only.
    Internal legacy filenames and nuamore.com swatch/media URLs are intentionally untouched.
  */
  function normalizeCopy(value) {
    if (!value) return value;

    return String(value)
      .replace(/Roselyn House/g, 'Roselyn')
      .replace(/\bNuamore\b/g, 'Roselyn')
      .replace(/\b5\s+Years?\s+Anniversary\b/gi, '10 Year Anniversary')
      .replace(/FIVE YEARS WORN/g, 'TEN YEARS WORN')
      .replace(/Five years\. Tens of thousands/g, 'Ten years. Tens of thousands')
      .replace(/giving back shop our biggest deals ever\./g, 'giving back with our biggest deals ever.')
      .replace(/dinnerit matches/g, 'dinner — it matches')
      .replace(/Swim, sweat, shower our jewelry stays flawless\./g, 'Swim, sweat, shower — our jewelry stays flawless.')
      .replace(/US\/Canadaorders/g, 'US/Canada orders')
      .replace(/30days/g, '30 days');
  }

  function normalizeTextNodes(root) {
    if (!root) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;
        if (/^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/i.test(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var node;
    while ((node = walker.nextNode())) {
      var next = normalizeCopy(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
  }

  function normalizeSafeAttributes(root) {
    if (!root || !root.querySelectorAll) return;

    var nodes = [];
    if (root.nodeType === 1) nodes.push(root);
    root.querySelectorAll('[alt],[title],[aria-label],a[href]').forEach(function (node) {
      nodes.push(node);
    });

    nodes.forEach(function (node) {
      ['alt', 'title', 'aria-label'].forEach(function (name) {
        if (!node.hasAttribute || !node.hasAttribute(name)) return;
        var oldValue = node.getAttribute(name);
        var newValue = normalizeCopy(oldValue);
        if (newValue !== oldValue) node.setAttribute(name, newValue);
      });

      if (node.matches && node.matches('a[href]')) {
        var href = node.getAttribute('href') || '';
        var corrected = href
          .replace('https://aubriellehouse.com', 'https://aubriellejewelry.com')
          .replace('http://aubriellehouse.com', 'https://aubriellejewelry.com')
          .replace('https://www.aubriellehouse.com', 'https://aubriellejewelry.com')
          .replace('http://www.aubriellehouse.com', 'https://aubriellejewelry.com');
        if (corrected !== href) node.setAttribute('href', corrected);
      }
    });
  }

  function fixShippingClaim(root) {
    if (window.RoselynRosewood && window.RoselynRosewood.shippingAlwaysFree) return;
    if (!root || !root.querySelectorAll) return;

    var labels = [];
    if (root.matches && root.matches('.geo-shipping-text')) labels.push(root);
    root.querySelectorAll('.geo-shipping-text').forEach(function (node) { labels.push(node); });

    labels.forEach(function (label) {
      Array.prototype.slice.call(label.childNodes).forEach(function (child) {
        if (child.nodeType === Node.TEXT_NODE && /\bFree\b/.test(child.nodeValue || '')) {
          child.nodeValue = child.nodeValue.replace(/\bFree\b/, 'Tracked');
        }
      });
    });
  }

  function nextBusinessDay() {
    var date = new Date();
    date.setDate(date.getDate() + 1);
    while (date.getDay() === 0 || date.getDay() === 6) {
      date.setDate(date.getDate() + 1);
    }
    return date;
  }

  function fixProductShipDate(root) {
    if (!root || !root.querySelectorAll) return;

    var dates = [];
    if (root.matches && root.matches('.geo-ship-date')) dates.push(root);
    root.querySelectorAll('.geo-ship-date').forEach(function (node) { dates.push(node); });
    if (!dates.length) return;

    var date = nextBusinessDay();
    var weekday = new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(date);
    var day = new Intl.DateTimeFormat('en-GB', { day: '2-digit' }).format(date);
    var month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
    var label = weekday + ', ' + day + ' ' + month;

    dates.forEach(function (node) {
      if (node.textContent !== label) node.textContent = label;
    });
  }

  function clean(root) {
    root = root || document.body;
    if (!root) return;
    normalizeTextNodes(root);
    normalizeSafeAttributes(root);
    fixShippingClaim(root);
    fixProductShipDate(root);
  }

  function scheduleClean() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      clean(document.body);
    });
  }

  function start() {
    clean(document.body);

    var observer = new MutationObserver(function () {
      scheduleClean();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['href', 'alt', 'title', 'aria-label']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
